import { recoverTokenInfo } from "@/utils/recoverTokenInfo";
import { useQuery } from "@tanstack/react-query";
import { useDeviceKey } from "./useDeviceKey";

export const fetchAgendaDetails = async (deviceKey: string, agendaId: string) => {
  if (!agendaId) {
    return "";
  }

  const url = `${import.meta.env.VITE_SMART_DEBRIEF_API}/v0/agenda/${agendaId}`;
  const initialToken = recoverTokenInfo();

  const response = await fetch(url, {
    method: "GET",
    headers: {
      accept: "text/plain",
      Authorization: `Bearer ${initialToken}`,
      "X-iBabs-Device-Id": deviceKey,
    },
    credentials: "include",
  });

  if (!response.ok) {
    throw new Error(`Response status: ${response.status}`);
  }

  const agendaDetails = await response.json();
  return agendaDetails;
};

export function useAgendaDetails(agendaId: string) {
  const deviceKey = useDeviceKey();

  return useQuery({
    queryKey: ["agendaItems", agendaId],
    queryFn: () => fetchAgendaDetails(deviceKey, agendaId),
    // staleTime: 1000 * 5,
    enabled: !!agendaId,
  });
}
